<template>
  <div class="deviceStatus">
    <b-container>
      <b-row v-if="deviceStatusData.length > 0">
        <b-col cols="12" v-for="(item, key) in deviceStatusData" :key="key">
          <div class="process-title">{{ item.process }}</div>
          <div class="device-data">
            <b-progress :max="item.deviceQty" height="3rem">
              <b-progress-bar
                v-for="(statusItem, statusKey) in deviceStatusData[key].status"
                :key="statusKey"
                :value="statusItem"
                :style="{
                  background:
                    statusKey == 'running'
                      ? '#00b152'
                      : statusKey == 'warning'
                      ? '#ff0000'
                      : statusKey == 'queue'
                      ? '#ffc100'
                      : statusKey == 'maintain'
                      ? '#cccdfe'
                      : statusKey == 'shunting'
                      ? '#09b0ff'
                      : statusKey == 'short'
                      ? '#99f98c'
                      : statusKey == 'offline'
                      ? '#cccccc'
                      : '#cccccc',
                }"
                class="progress-dec"
              >
                <div v-if="windowInnerWidth >= 992">
                  {{
                    statusKey == "running"
                      ? "運轉"
                      : statusKey == "warning"
                      ? "異常"
                      : statusKey == "queue"
                      ? "待機"
                      : statusKey == "maintain"
                      ? "維修"
                      : statusKey == "shunting"
                      ? "調車"
                      : statusKey == "short"
                      ? "短寸"
                      : statusKey == "offline"
                      ? "離線"
                      : "離線"
                  }}
                  {{ statusItem }}
                </div>
                <div v-else>
                  <div class="status-text">
                    {{
                      statusKey == "running"
                        ? "運轉"
                        : statusKey == "warning"
                        ? "異常"
                        : statusKey == "queue"
                        ? "待機"
                        : statusKey == "maintain"
                        ? "維修"
                        : statusKey == "shunting"
                        ? "調車"
                        : statusKey == "short"
                        ? "短寸"
                        : statusKey == "offline"
                        ? "離線"
                        : "離線"
                    }}
                  </div>
                  <div class="status-text">
                    {{ statusItem }}
                  </div>
                </div>
              </b-progress-bar>
            </b-progress>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col cols="12" v-for="(item, key) in deviceStatusDefault" :key="key">
          <div class="process-title">{{ item.process }}</div>
          <div class="device-data">
            <b-progress :max="item.deviceQty" height="3rem">
              <b-progress-bar
                v-for="(statusItem, statusKey) in deviceStatusDefault[key]
                  .status"
                :key="statusKey"
                :value="statusItem"
                :style="{
                  background:
                    statusKey == 'running'
                      ? '#00b152'
                      : statusKey == 'warning'
                      ? '#ff0000'
                      : statusKey == 'queue'
                      ? '#ffc100'
                      : statusKey == 'maintain'
                      ? '#cccdfe'
                      : statusKey == 'shunting'
                      ? '#09b0ff'
                      : statusKey == 'short'
                      ? '#99f98c'
                      : statusKey == 'offline'
                      ? '#cccccc'
                      : '#cccccc',
                  fontSize: '1rem',
                }"
              >
                {{
                  statusKey == "running"
                    ? "運轉"
                    : statusKey == "warning"
                    ? "異常"
                    : statusKey == "queue"
                    ? "待機"
                    : statusKey == "maintain"
                    ? "維修"
                    : statusKey == "shunting"
                    ? "調車"
                    : statusKey == "short"
                    ? "短寸"
                    : statusKey == "offline"
                    ? "離線"
                    : "離線"
                }}
                {{ statusItem }}
              </b-progress-bar>
            </b-progress>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "deviceStatus",
  props: {
    deviceStatusData: Array,
  },
  data() {
    return {
      deviceStatusDefault: [
        {
          process: "打頭",
          deviceQty: 0,
          status: {
            running: 0,
            queue: 0,
            warning: 0,
            offline: 0,
          },
        },
        {
          process: "輾牙",
          deviceQty: 0,
          status: {
            running: 0,
            queue: 0,
            warning: 0,
            offline: 0,
          },
        },
        {
          process: "熱處理",
          deviceQty: 0,
          status: {
            running: 0,
            queue: 0,
            warning: 0,
            offline: 0,
          },
        },
      ],
      windowInnerWidth: "",
    };
  },
  computed: {
    ...mapGetters({}),
  },
  created() {
    let vm = this;
    vm.setWindowInnerWidth();
    window.addEventListener("resize", vm.setWindowInnerWidth);
  },
  watch: {},
  methods: {
    setWindowInnerWidth() {
      let vm = this;
      vm.windowInnerWidth = window.innerWidth;
    },
  },
  destroyed(){
    let vm = this;
    window.removeEventListener("resize",vm.setWindowInnerWidth);
  }
};
</script>

<style scoped>
.deviceStatus {
  color: #707070;
  /* margin: 10px 20px 10px 0px; */
}
.process-title {
  display: inline-block;
  vertical-align: middle;
  margin: 20px 0px 20px 0px;
  font-size: 20px;
  width: 100px;
}
.device-data {
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 110px);
  margin: 20px 0px 20px 0px;
}
.progress-dec {
  cursor: default;
  font-size: 1rem;
  font-weight: 500;
}
.status-text {
  line-height: 14px;
}

@media (max-width: 992px) {
  .device-data {
    display: block;
    width: 100%;
    margin: 5px 0px 10px 0px;
  }
  .process-title {
    display: block;
    font-size: 20px;
    width: 100px;
    margin: 10px 0px 5px 0px;
    text-align: left;
  }
  .progress-dec {
    cursor: default;
    font-size: 0.8rem;
    font-weight: 500;
  }
}
</style>>




// WEBPACK FOOTER //
// src/components/deviceStatus.vue